<template>
  <nav :class="['c-navbar', isHidden]">
    <div class="c-navbar__body">
      <div class="c-navbar__brand">
        <router-link class="c-navbar__brand-link" to="/">
          <svg class="c-logo c-logo--casino c-logo--casino-inverted c-logo--casino-sm"><use xlink:href="#logo-gokkasten-inverted"></use></svg>
        </router-link>
      </div>
      
      <!-- <nav-bar-links v-if="$mq('md-min')"></nav-bar-links> -->

      <!-- <side-nav></side-nav> -->
    </div>

    <!-- <nav-bar-links v-if="$mq('sm-max')"></nav-bar-links> -->

    <favourites-nav-mobile v-if="user.isAuthenticated && $mq('sm-max')"></favourites-nav-mobile>
  </nav>
</template>

<script>
  // Vuex
  import { mapGetters } from 'vuex';

  // Components
  import NavBarLinks from './NavBarLinks.vue';
  import SideNav from './SideNav.vue';
 
  // Utilities
  import { watchScroll } from '@/utilities';

  export default {
    name: 'NavBar',
    
    components: {
      NavBarLinks,
      SideNav,
      FavouritesNavMobile: () => import(/* webpackChunkName: "FavouritesNavMobile" */'./FavouritesNavMobile.vue')
    },

    data () {
      return {
        scrollState: new watchScroll(),
      }
    },

    computed: {
      ...mapGetters([
        'user'
      ]),

      isHidden () {
        return this.scrollState.scrollingDown ? 'c-navbar--is-hidden' : '';
      }
    }
  };
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/components/NavBar.vue